// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import dateFormat from 'dateformat';
import { showModal } from '../actions';
import { COLOR, COLOR_STARTUS } from '../const'
// import ReactModal from "react-modal";

const OrderItem = ({ index }: { index: number }) => {
  // console.log('Item index', index)
  const order: any = useOrder(index);
  const { skip } = useSelector((state: any) => state.Search)

  // console.log(order)
  
  const dispatch = useDispatch();

  return (
    <div className={order.deliveryAt.status?styles.divTableRow:styles.divTableRowError} onClick={() => {
      dispatch(showModal(index))
    }}>
      <div className={styles.divTableCell}>{index+1+skip}</div>
      <div className={styles.divTableCell}>{order.trackingNo}</div>
      <div className={styles.divTableCell}>{order.isBox === undefined? 'ไม่ระบุ' :order.isBox?'มีกล่อง':'ไม่มีกล่อง'}</div>
      <div className={styles.divTableCell}>{order.shopInformation.name}</div>
      <div className={styles.divTableCell}>{order.delivery_service}</div>
      <div className={styles.divTableCell}>
        <div> {dateFormat(order.deliveryAt.dateDelivery, "H:MM")}</div>
        <div>{dateFormat(order.deliveryAt.dateDelivery, "ddd dd-mm-yyyy")}</div>
      </div>
      <div className={styles.divTableCell}>{(order.parcel === undefined ? 'Route' : order.parcel?'Parcel':'Route')}</div>
      <div className={styles.divTableCell}>{order.contact.name}</div>
      <div className={styles.divTableCell}>{order.contact.mobile}</div>
    </div>
  );
}



function useOrder(index: number) {
  const order = useSelector((state: any) => state.Order.orders[index])
  return order
}

const styles = {
  root: css`
      display: flex;
      justify-content: space-between;
      list-style-type: none;
      margin: 0;
      padding: 8px 12px;
  
    &:hover {
      background - color: #efefef;

      button {
      display: block;
  }
}

    button {
      display: none;
  }
`,
  divTableRow: css`
  display: table-row;
  color: ${COLOR['DARK_2']};
  font-size: 16px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  &:nth-child(odd) {
    background-color: ${COLOR['BLUE_DARK_OPA_1']};
    border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
  }
`,
divTableRowError: css`
display: table-row;
color: #ffffff;
font-size: 16px;
background-color: ${COLOR_STARTUS['CANCELED']};
border: #ffffff;
&:nth-child(odd) {
  background-color: ${COLOR_STARTUS['CANCELED']};
  border: 1px solid ${COLOR_STARTUS['CANCELED']};
}
`,
  divTableHeading: css`
background-color: #EEE;
display: table-header-group;
`,
  divTableCell: css`
border: 1px solid #999999;
display: table-cell;
padding: 25px 3px;
text-align: center;
border:0;
`,
  modal: css`
position: absolute;
height: 100%;
width: 600px;
top: 0px;
right: 0px;
background: #fff;
  `,
};

export default OrderItem;